import {createAction, props} from '@ngrx/store';
import {OauthMeUser} from '../../data/model';
import {CommerceErrorInterface} from '../error-handling/commerce-error';

export const loadCurrentUser = createAction('[CurrentUser] Load Current User');

export const loadCurrentUserSuccess = createAction(
  '[CurrentUser] Load Current User Success',
  props<{user: OauthMeUser}>(),
);

export const loadCurrentUserFailure = createAction(
  '[CurrentUser] Load Current User Failure',
  props<{error: CommerceErrorInterface}>(),
);
